import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiCalendar, FiUser, FiArrowRight } from 'react-icons/fi';
import './Blog.css';

const Blog = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Posts' },
    { id: 'style', name: 'Style Guide' },
    { id: 'trends', name: 'Trends' },
    { id: 'interviews', name: 'Interviews' },
    { id: 'sustainability', name: 'Sustainability' }
  ];

  const posts = [
    {
      id: 1,
      title: 'The Art of Layering: A Guide to Timeless Style',
      excerpt: 'Discover how to master the art of layering with pieces from our latest collection. From lightweight knits to structured outerwear.',
      author: 'Emma Clarke',
      date: 'Feb 12, 2026',
      category: 'style',
      image: '/images/tee-1.svg',
      readTime: '5 min read'
    },
    {
      id: 2,
      title: 'Spring/Summer 2026: The Trends to Know Now',
      excerpt: 'From electric blue moments to architectural silhouettes, we break down the key trends defining the season.',
      author: 'Marcus Chen',
      date: 'Feb 10, 2026',
      category: 'trends',
      image: '/images/tee-2.svg',
      readTime: '4 min read'
    },
    {
      id: 3,
      title: 'Behind the Seams: A Conversation with Maison Noir',
      excerpt: 'We sit down with the creative director of Maison Noir to discuss craftsmanship, inspiration, and the future of luxury.',
      author: 'Sophia Laurent',
      date: 'Feb 8, 2026',
      category: 'interviews',
      image: '/images/tee-3.svg',
      readTime: '7 min read'
    },
    {
      id: 4,
      title: 'Sustainable Luxury: Our Commitment to the Future',
      excerpt: 'Learn about our sustainability initiatives and how we\'re working to create a more responsible future for fashion.',
      author: 'James Worthington',
      date: 'Feb 5, 2026',
      category: 'sustainability',
      image: '/images/tee-4.svg',
      readTime: '6 min read'
    },
    {
      id: 5,
      title: 'The Perfect White Shirt: A Style Essential',
      excerpt: 'Why every wardrobe needs a perfectly crafted white shirt and how to style it for any occasion.',
      author: 'Emma Clarke',
      date: 'Feb 3, 2026',
      category: 'style',
      image: '/images/tee-1.svg',
      readTime: '4 min read'
    },
    {
      id: 6,
      title: 'Evening Elegance: Dressing for Spring Events',
      excerpt: 'From gallery openings to dinner parties, discover the perfect pieces for your spring calendar.',
      author: 'Sophia Laurent',
      date: 'Jan 30, 2026',
      category: 'style',
      image: '/images/tee-2.svg',
      readTime: '5 min read'
    }
  ];

  const filteredPosts = selectedCategory === 'all' 
    ? posts 
    : posts.filter(post => post.category === selectedCategory);

  const featuredPost = posts[0];

  return (
    <div className="blog-page">
      {/* Hero Section */}
      <section className="blog-hero">
        <div className="blog-hero-background">
          <img src={featuredPost.image} alt="Featured post" />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <div className="blog-hero-content">
            <span className="featured-tag">FEATURED</span>
            <h1 className="blog-hero-title">{featuredPost.title}</h1>
            <p className="blog-hero-excerpt">{featuredPost.excerpt}</p>
            <div className="blog-hero-meta">
              <span><FiUser /> {featuredPost.author}</span>
              <span><FiCalendar /> {featuredPost.date}</span>
              <span>{featuredPost.readTime}</span>
            </div>
            <Link to={`/blog/${featuredPost.id}`} className="read-more-btn">
              Read Article
              <FiArrowRight />
            </Link>
          </div>
        </div>
      </section>

      {/* Blog Content */}
      <section className="blog-content-section">
        <div className="container">
          {/* Categories */}
          <div className="blog-categories">
            {categories.map(category => (
              <button
                key={category.id}
                className={`category-btn ${selectedCategory === category.id ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category.id)}
              >
                {category.name}
              </button>
            ))}
          </div>

          {/* Posts Grid */}
          <div className="blog-grid">
            {filteredPosts.map((post, index) => (
              <article key={post.id} className={`blog-card ${index === 0 ? 'featured' : ''}`}>
                <Link to={`/blog/${post.id}`} className="blog-card-image">
                  <img src={post.image} alt={post.title} loading="lazy" />
                </Link>
                <div className="blog-card-content">
                  <div className="blog-card-meta">
                    <span className="blog-category">{categories.find(c => c.id === post.category)?.name}</span>
                    <span className="blog-date">{post.date}</span>
                  </div>
                  <h2 className="blog-card-title">
                    <Link to={`/blog/${post.id}`}>{post.title}</Link>
                  </h2>
                  <p className="blog-card-excerpt">{post.excerpt}</p>
                  <div className="blog-card-footer">
                    <span className="blog-author"><FiUser /> {post.author}</span>
                    <span className="blog-read-time">{post.readTime}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>

          {/* Load More */}
          <div className="blog-load-more">
            <button className="load-more-btn">LOAD MORE ARTICLES</button>
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="blog-newsletter">
        <div className="container">
          <div className="newsletter-container">
            <h2>The Edit</h2>
            <p>Subscribe for exclusive access to new collections, early drops, and special offers.</p>
            <form className="newsletter-form">
              <input type="email" placeholder="Enter your email" />
              <button type="submit">SUBSCRIBE</button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;